import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Home", testid: "nav-link-home", end: true },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-200/80 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" onClick={() => setOpen(false)} aria-label="Foresight Global Systems — home">
            <Logo />
          </Link>
          <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `font-sans text-sm font-medium tracking-wide transition-colors duration-300 ${
                    isActive ? "text-gold-deep" : "text-navy hover:text-gold-deep"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <Link
              to="/contact"
              data-testid="header-cta-button"
              className="hidden sm:inline-flex items-center rounded-full bg-gold px-5 py-2.5 font-sans text-sm font-semibold text-navy-dark transition-colors duration-300 hover:bg-gold-hover"
            >
              Talk With Us
            </Link>
            <button
              className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-full border border-slate-200 text-navy"
              onClick={() => setOpen(!open)}
              aria-label={open ? "Close menu" : "Open menu"}
              data-testid="mobile-menu-toggle"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            key={location.pathname}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden border-t border-slate-200/80 bg-white"
            aria-label="Mobile"
          >
            <div className="px-4 py-4 flex flex-col gap-1">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.end}
                  data-testid={`mobile-${l.testid}`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `rounded-lg px-4 py-3 font-sans text-base font-medium ${
                      isActive ? "bg-skybrand-50 text-gold-deep" : "text-navy"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                data-testid="mobile-header-cta-button"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center rounded-full bg-gold px-5 py-3.5 font-sans text-base font-semibold text-navy-dark"
              >
                Talk With Us
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
